
const AwsConfig = (): object => {
  return {
    Auth: {
      region: "eu-west-2",
      userPoolId: process.env.APP_AUTH_USERPOOLID,
      userPoolWebClientId: process.env.APP_AUTH_CLIENTID,
      authenticationFlowType: "AUTHORIZATION_CODE_GRANT",
      oauthDomain: process.env.APP_AUTH_DOMAINNAME,
      oauth: {
        domain: process.env.APP_AUTH_DOMAINNAME,
        scope: [
          "email",
          "openid",
          "aws.cognito.signin.user.admin",
        ],
        redirectSignIn: process.env.APP_FEASIBILITY_STUDYTEAM_UI,
        redirectSignOut: process.env.APP_FEASIBILITY_STUDYTEAM_UI,
        responseType: "token",
      },
    },
  };
};

export default AwsConfig;
